import m from "../../prime-src/prepare";
import Move from "./Move";
import Reset from "./Reset";
import Exit from "./Exit";

export default function FSTimezone() {
  return (
    <div id="search-timezone-container" className="fs-container" style={{display:'none'}}>
      <div className="fs-name">Fuzzy search Timezone</div>
      <Move></Move>
      <textarea id="search-timezone" className="fs-input"></textarea>
      <div id="search-timezone-list" className="fs-list"></div>
      <Reset></Reset>
      <Exit onClick={() => m.$choose_timezone.trigger('click')}></Exit>
    </div>
  );
}
